export const clearAccountId = () => {
  localStorage.removeItem("accountId");
};
